import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgBsToastService } from 'ng-bs-toast-service';
import { HttpErrorResponse } from '@angular/common/http';
import { Breadcrumb } from '../../../shared/components';
import { ConfigurationsService } from '../../configurations.service';
import { Version } from '../version.model';

@Component({
    selector: 'app-form-version',
    standalone: false,
    templateUrl: './form-version.component.html',
})
export class FormVersionComponent {
    constructor(
        private activatedRoute: ActivatedRoute,

        private configurationsService: ConfigurationsService,
        private router: Router,
        private toastService: NgBsToastService
    ) {}

    loading = { main: false, modal: false, save: false };

    breadcrumb: Breadcrumb[] = [
        { title: 'Configurações', route: ['/configurations'] },
    ];

    isEditing = false;

    title = 'Criar Versão';

    version: Version = {} as Version;

    ngOnInit() {
        const id = this.activatedRoute.snapshot.paramMap.get('id');
        if (id) {
            this.isEditing = true;
            this.title = 'Editar versão';
            this.breadcrumb.push({ title: 'Editar versão' });
            this.loading.main = true;
            this.configurationsService.getById(id).subscribe({
                    next: (res) => (this.version = res),
                    error: (err: HttpErrorResponse) =>this.toastService.send(`Erro ${err.status}`, err.error.message || err.message, 'danger'),
            }).add(() => (this.loading.main = false));
        } else {
            this.isEditing = false;
            this.title = 'Nova versão';
            this.breadcrumb.push({ title: 'Nova versão' });
        }
    }

    saveVersion() {
        this.loading.save = true;

        this.version.isDeprecated = this.version.isDeprecated ? true : false;

        const request = this.version.id && this.isEditing
            ? this.configurationsService.update(this.version)
            : this.configurationsService.create(this.version);

        request
            .subscribe({
                next: () => {
                    this.router.navigate(['/configurations']);
                    this.toastService.send( 'Sucesso','Configuração salva com sucesso!', 'success')
                },
                error: (err: HttpErrorResponse) => this.toastService.send(`Erro ${err.status}`, err.error.message || err.message,'danger'),
            }).add(() => (this.loading.save = false));
    }
}
